import { Button, Col, Form, Radio, Row, Select, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import ResponsiveContainer from '../../../components/ResponsiveContainer';
import { useInvolucradosList } from '../useInvolucradosList';

const { Title } = Typography;

const useList = (isChecked, title, type, name) => {
  const [check, setCheck] = useState(isChecked);
  const [InvolucradosList] = useInvolucradosList(title, type, name);

  const handleChangeCheck = (e) => {
    setTimeout(() => {
      setCheck(e.target.value);
    }, 0);
  };

  const List = () => (
    <>
      <Row gutter={[8, 8]} style={{ textAlign: 'start' }}>
        <Col xs={12} md={6} style={{ marginBottom: '20px' }}>
          <Title
            level={5}
            style={{ marginRight: '10px' }}
          >{`Hubo ${title}?`}</Title>
        </Col>
        <Col xs={12} md={6} style={{ marginBottom: '20px' }}>
          <Radio.Group onChange={(e) => handleChangeCheck(e)} value={check}>
            <Space direction="">
              <Radio value>Si</Radio>
              <Radio value={false}>No</Radio>
            </Space>
          </Radio.Group>
        </Col>
      </Row>

      {check && (
        <div>
          <InvolucradosList title={title} name={name} />
        </div>
      )}
    </>
  );

  return [check, List];
};

const Involucrados = ({
  datosIngresados,
  handleSetDatosIngresados,
  setStep,
  current
}) => {
  const [checkTerceros, ListTerceros] = useList(
    datosIngresados.tiene_terceros ? datosIngresados.tiene_terceros : false,
    'Terceros',
    1,
    'terceros'
  );
  const [checkLesionados, ListLesionados] = useList(
    datosIngresados.tiene_lesionados ? datosIngresados.tiene_lesionados : false,
    'Lesionados',
    0,
    'lesionados'
  );
  const [checkTestigos, ListTestigos] = useList(
    datosIngresados.tiene_testigos ? datosIngresados.tiene_testigos : false,
    'Testigos',
    0,
    'testigos'
  );
  const [checkAutoridad, setCheckAutoridad] = useState(
    !!datosIngresados.autoridad
  );
  const [autoridad, setAutoridad] = useState(null);
  const [form] = Form.useForm();

  const onFinish = () => {
    handleSetDatosIngresados({
      nombre_conductor: datosIngresados.nombre_conductor,
      fecha_siniestro: datosIngresados.fecha_siniestro,
      hora_siniestro: datosIngresados.hora_siniestro,
      circunstancia_ocurrencia: datosIngresados.circunstancia_ocurrencia,
      velocidad_circulacion: datosIngresados.velocidad_circulacion,
      latitud: datosIngresados.latitud,
      longitud: datosIngresados.longitud,
      prefix: '+595',
      id_departamento: datosIngresados.id_departamento,
      id_distrito: datosIngresados.id_distrito,
      departamentoLabel: datosIngresados.departamentoLabel,
      distritoLabel: datosIngresados.distritoLabel,
      domicilio: datosIngresados.domicilio,
      terceros: form.getFieldsValue().terceros
        ? form.getFieldsValue().terceros
        : datosIngresados.terceros,
      tiene_terceros: checkTerceros,
      lesionados: form.getFieldsValue().lesionados
        ? form.getFieldsValue().lesionados
        : datosIngresados.lesionados,
      tiene_lesionados: checkLesionados,
      testigos: form.getFieldsValue().testigos
        ? form.getFieldsValue().testigos
        : datosIngresados.testigos,
      tiene_testigos: checkTestigos,
      autoridad,
      checkAutoridad,
      danios_vehiculo: datosIngresados.danios_vehiculo
    });
    setStep(current + 1);
  };

  const goBack = () => {
    setStep(current - 1);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  return (
    <>
      <ResponsiveContainer>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          initialValues={{
            terceros: datosIngresados.terceros
              ? datosIngresados.terceros
              : [{ nombres: '' }],
            lesionados: datosIngresados.lesionados
              ? datosIngresados.lesionados
              : [{ nombres: '' }],
            testigos: datosIngresados.testigos
              ? datosIngresados.testigos
              : [{ nombres: '' }],
            autoridad: datosIngresados.autoridad
          }}
        >
          <ListTerceros />
          <ListLesionados />
          <ListTestigos />
          <Row style={{ textAlign: 'start' }}>
            <Col
              xs={12}
              md={6}
              style={{
                marginBottom: '20px'
              }}
            >
              <Title level={5}>Intervino una autoridad?</Title>
            </Col>
            <Col
              xs={12}
              md={12}
              style={{
                marginBottom: '20px'
              }}
            >
              <Radio.Group
                onChange={(e) => setCheckAutoridad(e.target.value)}
                value={checkAutoridad}
                style={{
                  marginLeft: '4px'
                }}
              >
                <Space direction="">
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Space>
              </Radio.Group>
            </Col>
          </Row>
          <Row style={{ textAlign: 'start' }}>
            {checkAutoridad && (
              <Col xs={12} md={6}>
                <Form.Item
                  name="autoridad"
                  label="Elegir Autoridad"
                  rules={[
                    {
                      required: true,
                      message: 'Campo requerido'
                    }
                  ]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    placeholder="Elegir Autoridad"
                    value={autoridad}
                    onChange={(value) => {
                      setAutoridad(value);
                    }}
                  >
                    {[
                      { id: '1', descripcion: 'Policía Nacional' },
                      { id: '2', descripcion: 'Policía Municipal' }
                    ].map((item) => (
                      <Select.Option key={item.id} value={item.descripcion}>
                        {item.descripcion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>
          <Button style={{ margin: 10 }} onClick={goBack}>
            Anterior
          </Button>
          <Button type="primary" htmlType="submit">
            Siguiente
          </Button>
        </Form>
      </ResponsiveContainer>
    </>
  );
};

export default Involucrados;
